import React, { useState } from 'react'
import {useNavigate, useParams} from 'react-router'
import styled from 'styled-components'
import theme from '@shared/utils/theme'
import moment from 'moment'
import MonthYear from '@shared/components/MonthYear'
import { declarationData } from './DeclarationPage'
import { createDeclaration } from '../../services/declaration-services'
import Icon from '@shared/components/Icon';

const Container = styled.div`
  display: flex;
  background-color: ${theme.palette.light_grey};
  padding: 10px 20px;
  justify-content: space-between;
  
  &.active {
      cursor: pointer;
      &:hover {
        background-color: ${ theme.palette.grey };
      }
    }
  
  > .link {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-decoration: underline;
  }
`

export default function DeclarationLine({ month, ...props }) {

  const navigate = useNavigate()
  const params = useParams()

  const [actionDisable, setActionDisabled] = useState(false)

  const declare = async () => {
    // Avoid double creation
    if (!actionDisable) {
      setActionDisabled(true)

      if (!month.declaration) {
        const declarationInput = `
        recordId: "${month.recordId}"
        period: "${month.period}"
      `
        const response = await createDeclaration(declarationInput, declarationData)
        month.declaration = response.data.createDeclaration
      }
      month.date = month.date.toDate()
      navigate({
        pathname: `/declaration/${params.id}/declare` }, {
        state: { month }
      })
      return true
    }
  }

  let content
  if (month.canDeclare) {
    content = <span className="link">Je déclare mes frais<Icon name="chevron_right" /></span>
  } else if (month.declaration) {
    content = <span>{ month.declaration.hours } heures déclarées {
      (month.declaration && !month.declaration.basageId) && `le ${month.declaration.declareDate ? moment(month.declaration.declareDate).format('DD MMM YYYY') : ''}`}</span>
  } else {
    content = <span>Non déclaré</span>
  }

  const className = month.canDeclare ? 'active' : ''
  const action = month.canDeclare ? declare : null

  return <Container className={className} onClick={action}>
    <MonthYear date={ month.date._d } />
    { content }
  </Container>
}
